import React from 'react';
import { connect } from 'react-redux';
import MediaQuery from 'react-responsive';

import {
    displayableCashback,
    getMerchantCardUrl,
    renderPluralConditional,
    isMultiDiscount,
    isMultiDiscountOffline,
    hasCashback,
    hasDisplayableCoupon,
    hasOffline,
    hasCashbackOffline,
    hasOnAndOffCashback,
    hasEbonCashback
} from '../../../services/partner/utils';
import {
    isBilletterie,
    getBilletterieMerchantUrl,
    hasBilletteriePrice
} from '../../../services/billetterie/utils';

import { STATIC_ROOT, HEADER_DESKTOP_MEDIA_QUERY } from '../../../constants';

import SvgComponent from '../../SvgComponent';
import LocalizedNavLink from '../../router/LocalizedNavLink';
import BilletteriePriceComponent from '../../partner/BilletteriePriceComponent';

const renderUpTo = (partner, UPTO, isOffline) =>
    partner &&
    ((!isOffline && isMultiDiscount(partner)) || (isOffline && isMultiDiscountOffline(partner)))
        ? UPTO
        : '';

const mapStateToPropsResultCashback = state => ({
    REFUND: state.i18n.feature.partenaire.rembourse,
    IMMEDIATE_DISCOUNT: state.i18n.feature.partenaire.IMMEDIATE_DISCOUNT,
    OFFERED: state.i18n.feature.partenaire.offert,
    UPTO: state.i18n.feature.partenaire.jusqua,
    ONLINE: state.i18n.feature.partenaire.ONLINE,
    OFFLINE: state.i18n.feature.partenaire.OFFLINE,
    EBON_REFUND: state.i18n.feature.partenaire.EBON_REFUND,
    TICKETING: state.i18n.feature.partenaire.TICKETING,
    TICKETING_REFUND: state.i18n.feature.partenaire.TICKETING_REFUND,
    FROM_PRICE: state.i18n.feature.partenaire.FROM_PRICE
});
const ResultCashback = connect(mapStateToPropsResultCashback)(
    ({ partner, REFUND, IMMEDIATE_DISCOUNT, UPTO, ONLINE }) =>
        hasCashback(partner) ? (
            <div className="value">
                <SvgComponent
                    src={`${STATIC_ROOT}/picto-en-ligne.svg`}
                    width="20"
                    height="20"
                    aria-hidden="true"
                    focusable="false"
                />
                {renderUpTo(partner, UPTO)}&nbsp;
                <span>
                    {displayableCashback(
                        partner.mostDisplayableDiscountOnline.percent,
                        partner.mostDisplayableDiscountOnline.fixed
                    )}
                </span>
                &nbsp;
                {partner.qwertys ? (
                    IMMEDIATE_DISCOUNT
                ) : (
                    <React.Fragment>
                        {renderPluralConditional(
                            REFUND,
                            () =>
                                partner &&
                                (partner.mostDisplayableDiscountOnline.fixed > 1 ||
                                    partner.mostDisplayableDiscountOnline.percent > 1)
                        )}
                        &nbsp;{ONLINE}
                    </React.Fragment>
                )}
            </div>
        ) : null
);
const ResultCashbackOffline = connect(mapStateToPropsResultCashback)(
    ({ partner, REFUND, UPTO, OFFLINE }) =>
        hasOffline(partner) && hasCashbackOffline(partner) ? (
            <div className="value">
                <SvgComponent
                    src={`${STATIC_ROOT}/picto-magasin.svg`}
                    width="20"
                    height="20"
                    aria-hidden="true"
                    focusable="false"
                />
                {renderUpTo(partner, UPTO, true)}&nbsp;
                <span>
                    {displayableCashback(
                        partner.mostDisplayableDiscountOffline.percent,
                        partner.mostDisplayableDiscountOffline.fixed
                    )}
                </span>
                &nbsp;
                {renderPluralConditional(
                    REFUND,
                    () =>
                        partner &&
                        (partner.mostDisplayableDiscountOffline.fixed > 1 ||
                            partner.mostDisplayableDiscountOffline.percent > 1)
                )}
                &nbsp;{OFFLINE}
            </div>
        ) : null
);
const ResultCashbackEbon = connect(mapStateToPropsResultCashback)(
    ({ partner, OFFERED, EBON_REFUND }) =>
        hasEbonCashback(partner) ? (
            <div className="value">
                <SvgComponent
                    src={`${STATIC_ROOT}/picto-ebon.svg`}
                    width="21"
                    height="16"
                    aria-hidden="true"
                    focusable="false"
                />
                <span>
                    {displayableCashback(
                        partner.ebonDiscount.cashback.percent.value,
                        partner.ebonDiscount.cashback.fixed.value
                    )}
                </span>
                &nbsp;
                {renderPluralConditional(
                    OFFERED,
                    () =>
                        partner &&
                        (partner.ebonDiscount.cashback.percent.value > 1 ||
                            partner.ebonDiscount.cashback.fixed.value > 1)
                )}
                &nbsp;{EBON_REFUND}
            </div>
        ) : null
);
// Prix « à partir de » de la carte ; à défaut de prix le cashback, puis le type seul
const ResultCashbackBilletterie = connect(mapStateToPropsResultCashback)(
    ({ partner, OFFERED, FROM_PRICE, TICKETING, TICKETING_REFUND }) => (
        <div className="value">
            <SvgComponent
                src={`${STATIC_ROOT}/picto-billetterie.svg`}
                width="21"
                height="15"
                aria-hidden="true"
                focusable="false"
            />
            {hasBilletteriePrice(partner) ? (
                <React.Fragment>
                    {FROM_PRICE}&nbsp;
                    <BilletteriePriceComponent partner={partner} valueTag="span" />
                </React.Fragment>
            ) : hasEbonCashback(partner) ? (
                <React.Fragment>
                    <span>
                        {displayableCashback(
                            partner.ebonDiscount.cashback.percent.value,
                            partner.ebonDiscount.cashback.fixed.value
                        )}
                    </span>
                    &nbsp;
                    {renderPluralConditional(
                        OFFERED,
                        () =>
                            partner.ebonDiscount.cashback.percent.value > 1 ||
                            partner.ebonDiscount.cashback.fixed.value > 1
                    )}
                    &nbsp;{TICKETING_REFUND}
                </React.Fragment>
            ) : (
                TICKETING
            )}
        </div>
    )
);

const mapStateToPropsResultCodeReduction = state => ({
    CODE: state.i18n.feature.partenaire.code,
    DEREDUCTION: state.i18n.feature.partenaire.dereduction
});
const ResultCodeReduction = connect(mapStateToPropsResultCodeReduction)(
    ({ partner, CODE, DEREDUCTION, cssClass }) =>
        hasDisplayableCoupon(partner) ? (
            <div className={`value ${cssClass ? cssClass : ''}`}>
                <SvgComponent
                    src={`${STATIC_ROOT}/code-promo.svg`}
                    width="15"
                    height="18"
                    aria-hidden="true"
                    focusable="false"
                />
                <span>{partner.couponCount}</span>&nbsp;
                {renderPluralConditional(CODE, () => partner.couponCount > 1)}
                &nbsp;{DEREDUCTION}
            </div>
        ) : null
);

const hasStackedOffers = partner =>
    hasOnAndOffCashback(partner) || (hasCashback(partner) && hasDisplayableCoupon(partner));

export const ResultComponent = ({ partner, onClick }) => (
    <li className={`resultat ${hasStackedOffers(partner) ? 'large' : ''}`}>
        {isBilletterie(partner) ? (
            // Zone billetterie servie par une autre application : lien hors routeur
            <a href={getBilletterieMerchantUrl(partner)} onClick={onClick}>
                <div className="resultat-conteneur flex-container-h flex-center-alt">
                    <div className="partnerName">{partner.name}</div>
                    <div className="resultat-valeur">
                        <ResultCashbackBilletterie partner={partner} />
                    </div>
                </div>
            </a>
        ) : hasEbonCashback(partner) ? (
            <LocalizedNavLink to={getMerchantCardUrl(partner, false, true)} onClick={onClick}>
                <div className="resultat-conteneur flex-container-h flex-center-alt">
                    <div className="partnerName">{partner.name}</div>
                    <div className="resultat-valeur">
                        <ResultCashbackEbon partner={partner} />
                    </div>
                </div>
            </LocalizedNavLink>
        ) : (
            <LocalizedNavLink
                to={getMerchantCardUrl(
                    partner,
                    !hasCashback(partner) && !hasDisplayableCoupon(partner)
                )}
                onClick={onClick}>
                <div className="resultat-conteneur flex-container-h flex-center-alt">
                    <div className="partnerName">{partner.name}</div>
                    <div className="resultat-valeur">
                        <React.Fragment>
                            {hasCashback(partner) && <ResultCashback partner={partner} />}
                            {hasOnAndOffCashback(partner) && (
                                <MediaQuery query={HEADER_DESKTOP_MEDIA_QUERY}>
                                    {matches => (matches ? <br /> : '')}
                                </MediaQuery>
                            )}
                            {hasOffline(partner) && hasCashbackOffline(partner) && (
                                <ResultCashbackOffline partner={partner} />
                            )}
                            {hasCashback(partner) && hasDisplayableCoupon(partner) && (
                                <ResultCodeReduction partner={partner} cssClass="coupon-inline" />
                            )}
                        </React.Fragment>
                    </div>
                    <div className="coupon">
                        {!hasCashback(partner) && hasDisplayableCoupon(partner) && (
                            <ResultCodeReduction partner={partner} />
                        )}
                    </div>
                </div>
            </LocalizedNavLink>
        )}
    </li>
);



// WEBPACK FOOTER //
// ./src/components/header/search/ResultComponent.js